import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  params: {},
  byId: {},
});

export function studentGoalsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_STUDENT_GOALS_DOWNLOAD:
      return {
        ...state,
        actionsloading: true
      };
    case actionTypes.GET_STUDENT_GOALS:
      return {
        ...state,
        actionsloading: true
      };
    case actionTypes.GET_STUDENT_GOALS_SUCCESS:
      return {
        ...state,
        studentGoalsBank: action.payload.responceObject.records.goals_comment_bank || {},
        student_list: action.payload.responceObject.records.student_list || {},
        studentGoal: action.payload.responceObject.records.student_goals || {},
        pre_signed_URL: action.payload.responceObject.records.pre_signed_URL || '',
        actionsloading: false
      };
    case actionTypes.GET_STUDENT_GOALS_FAIL:
      return {
        ...state,
        error: action.payload,
        actionsloading: false,
      };
    case actionTypes.SAVE_STUDENT_GOALS_FAIL:
    case actionTypes.SAVE_STUDENT_GOALS_SUCCESS:
      return {
        ...state,
        actionsloading: true,
        saveStudentGoal: false,
      };
    case actionTypes.SAVE_STUDENT_GOALS:
      return {
        ...state,
        actionsloading: true,
        saveStudentGoal: true,
      };
    default:
      return state;
  }
}
